'use strict';
import * as $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal from "./com.raquo.airstream.misc.-Map-Signal.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProcessor$0024 from "./com.raquo.laminar.keys.-Event-Processor$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm from "./dev.cheleb.scalamigen.-Form.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_package$package$$anon$3(f$2, zero$2) {
  this.HP = null;
  this.HQ = null;
  this.HO = null;
  this.HP = f$2;
  this.HQ = zero$2;
  $j_dev$002echeleb$002escalamigen$002e$002dForm.$f_Ldev_cheleb_scalamigen_Form__$init$__V(this);
}
export { $c_Ldev_cheleb_scalamigen_package$package$$anon$3 as $c_Ldev_cheleb_scalamigen_package$package$$anon$3 };
$p = $c_Ldev_cheleb_scalamigen_package$package$$anon$3.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_package$package$$anon$3;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_package$package$$anon$3() {
}
export { $h_Ldev_cheleb_scalamigen_package$package$$anon$3 as $h_Ldev_cheleb_scalamigen_package$package$$anon$3 };
$h_Ldev_cheleb_scalamigen_package$package$$anon$3.prototype = $p;
$p.dJ = (function() {
  return this.HO;
});
$p.dt = (function(x$1) {
  this.HO = x$1;
});
$p.du = (function(x$1) {
});
$p.dx = (function(label, required, factory) {
  return factory.cX(required, label);
});
$p.UK = (function(s) {
  var this$1 = this.HP.j(s);
  return (this$1.k() ? new $j_java$002elang$002e$002dObject.$c_s_Some(this.HQ) : this$1);
});
$p.bt = (function(path, variable, factory, errorBus) {
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(factory.xZ(), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.hv().kH($j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$c_Lcom_raquo_airstream_misc_MapSignal(), variable.a4(), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((str$2) => $j_java$002elang$002e$002dObject.$dp_toString__T(str$2))), $j_java$002elang$002e$002dObject.$m_s_None$())), new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_modifiers_EventListener(($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProcessor$0024.$m_Lcom_raquo_laminar_keys_EventProcessor$().bU($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.ir(), false, false)).js(), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$3) => {
    var this$5 = this.UK(v$3);
    if ((!this$5.k())) {
      $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__set__O__V(variable, this$5.C());
    }
  })))]));
});
var $d_Ldev_cheleb_scalamigen_package$package$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_package$package$$anon$3, "dev.cheleb.scalamigen.package$package$$anon$3", ({
  jp: 1,
  a2: 1
}));
export { $d_Ldev_cheleb_scalamigen_package$package$$anon$3 as $d_Ldev_cheleb_scalamigen_package$package$$anon$3 };
